import { AnexoServiceName } from "@/utils/common/constants";
import { IServiceAnexo } from "../base/iServiceAnexo";

export default class FormulaPadraoAnexoService extends IServiceAnexo {
    constructor() {
        super(AnexoServiceName.FormulaPadraoAnexo);
    }
}
